import React, { memo } from 'react';

import { ColorBorderLight, ColorVariantsLight } from '@/constants/color';

import { Props } from './types';

/**
 * @deprecated Do not use this component. Use the base components at the root of the UI folder instead.
 */
const Badge = ({ color, text, children, className, fontSize }: Props) => {
  const colorClasses = `${ColorVariantsLight[color]} ${ColorBorderLight[color]}`;

  return (
    <span
      className={`${colorClasses} font-bold inline-flex items-center px-2 py-0.5 rounded-full shadow-xs ${fontSize ? fontSize : 'text-xs'} leading-4 capitalize ${className ? className : ''}`}>
      {children || text}
    </span>
  );
};

export default memo(Badge);
